<template>
  <div>
    <div
      v-if="shortCard"
      class="static border-l-8 h-full relative bg-white rounded shadow-md border-purple w-full"
      :class="!includedInSub ? 'opacity-50' : ''"
    >
      <div
        id="card-content"
        class="p-4"
      >
        <div
          id="card-top"
          class="pb-4 border-b-2 border-matte-gray flex justify-start items-center"
        >
          <img
            src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/online-access-icon.png"
            class="mr-4"
            :class="large ? 'h-14 w-14' : 'h-10 w-10'"
          />
          <h5
            class="leading-tight text-left"
            :class="large ? 'text-2xl' : ''"
          >
            Customized Packages
          </h5>
        </div>
        <div
          id="card-bottom"
          class="pt-4 text-center"
        >
          <p class="text-sm font-bold">
            Savings and Customized Options <br />
            for Your Unique Needs
          </p>
          <p class="py-4 text-sm">
            Call for Pricing
          </p>
          <slot name="button" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="relative border-l-8 h-full rounded bg-white shadow-md border-purple w-full"
      :class="!includedInSub ? 'opacity-50' : ''"
    >
      <div
        id="long-card-content"
        class="p-4"
      >
        <div
          id="long-card-top"
          class="pb-4 border-b-2 border-matte-gray"
        >
          <div class="flex justify-start items-center">
            <img
              src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/customized-packages.png"
              class="mr-4"
              :class="large ? 'h-14' : 'h-10'"
            />
            <h5
              class="leading-tight text-left"
              :class="large ? 'text-2xl' : ''"
            >
              Customized Packages
            </h5>
          </div>
          <p
            v-if="shortCard"
            class="text-sm font-bold text-center pt-4"
          >
            Savings and Customized Options
            for Your Unique Needs
          </p>
        </div>
        <div
          id="long-card-bottom"
          class="text-center"
        >
          <p class="text-sm pb-2 text-left pt-4">
            Customized Savings On:
          </p>
          <ul class="pb-4 text-left">
            <li class="text-sm mb-1">
              <span class="font-bold text-purple">Groups 5+ Get Deeper Discounts</span>
            </li>
            <li class="text-sm mb-1">
              <span class="font-bold text-purple">Save on Group Subscriptions </span>
            </li>
            <li class="text-sm mb-1">
              <span class="font-bold text-purple">Save on Individual Course Purchases </span>
            </li>
            <li class="text-sm mb-1">
              <nuxt-link
                to="/group-sales/hep"
                class="font-bold text-purple text-sm"
              >
                Add Integrated HEP Platform
              </nuxt-link>
            </li>
          </ul>
          <div class="absolute bottom-0 right-0 left-0">
            <slot name="button" />
            <p class="py-4 font-bold text-sm">
              Call (615) 647-8486 for Pricing
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomizedPackages',
  props: {
    shortCard: {
      type: Boolean,
      default: true,
    },
    large: {
      type: Boolean,
      default: true,
    },
    includedInSub: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
